import { DatePipe, DecimalPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StarRatingComponent } from '@uc/shared/ui';
import {
	CdnPathPipe,
	EntitiesPipe,
	HighlightSearchPipe,
	LastNameInitialPipe,
} from '@uc/utilities';
import { UniversityReview } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-review-header',
	templateUrl: './review-header.component.html',
	imports: [
		NgOptimizedImage,
		DecimalPipe,
		DatePipe,
		CdnPathPipe,
		EntitiesPipe,
		HighlightSearchPipe,
		LastNameInitialPipe,
		StarRatingComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewHeaderComponent {
	review = input.required<UniversityReview>();
	avatar = input.required<string>();
	searchTerm = input.required<string | null>();
}
